export const NO_CONDITION = '-1';
